import React from "react";
import Navbar from "./components/Navbar/index";
import Login from "./components/Login/index";
import Overview from "./components/Overview/index";
import Profile from "./components/Profile/index";
import Budget from "./components/BudgetDropdown/index";
// import Resources from "./components/Resources/index";
import PasswordHelp from "./components/PasswordHelp/index";
import PasswordReset from "./components/PasswordReset/index";
import Impersonate from "./components/Impersonate/index";
import AppointmentApp from "./components/AppointmentApp/index";
import NotFound from "./components/NotFound/index";
import ContactUs from "./components/ContactUs/index";
import * as utils from "./shared/utils"
import "./App.css";
import {
  budgetURL,
  homeURL,
  loginURL,
  overviewURL,
  passwordHelpURL,
  passwordResetURL,
  profileURL,
  // resourcesURL,
  unsubscribeEmailURL,
  impersonateURL, 
  scheduleURL,
  contactUsURL,
} from "./shared/urls/app";
import {history} from './shared/helpers/_history'
import {Redirect, Route, Router, Switch} from "react-router-dom";
import ReactGA from 'react-ga';
import {GA_TRACKING_ID} from "./constants/index";
import UnsubscribeEmail from "./components/UnsubscribeEmail";

export default class ClientPortal extends React.Component {
  constructor(props) {
    super(props);

    var storedActiveItem = "";
    this.state = {
      activeItem: storedActiveItem
    };

    this.updateNav = this.updateNav.bind(this);

    ReactGA.initialize(GA_TRACKING_ID);
  }

  updateNav(navItem) {
    this.setState({activeItem: navItem });
  }

  render() {
    return (
      <Router history={history} >
        <div>
          <Switch>
            <Route path={loginURL} component={Login} />
            <PrivateRoute exact path={homeURL} component={Overview} activeItem={this.state.activeItem} updateNav={this.updateNav} />
            <PrivateRoute path={overviewURL} component={Overview} activeItem={this.state.activeItem} updateNav={this.updateNav} />
            <PrivateRoute path={profileURL} component={Profile} activeItem={this.state.activeItem} updateNav={this.updateNav} />
            <PrivateRoute path={budgetURL} component={Budget} activeItem={this.state.activeItem} updateNav={this.updateNav} />
            {/* <PrivateRoute path={resourcesURL} component={Resources} activeItem={this.state.activeItem} updateNav={this.updateNav} /> */}
            <PublicRoute path={unsubscribeEmailURL} component={UnsubscribeEmail} />
            <PublicNoNavRoute path={passwordResetURL} component={PasswordReset} />
            <PublicNoNavRoute path={passwordHelpURL} component={PasswordHelp} />
            <PublicRoute path={impersonateURL} component={Impersonate} />
            <PublicRoute path={scheduleURL} component={AppointmentApp} />
            <PublicRoute path={contactUsURL} component={ContactUs} />
            <PrivateRoute component={NotFound} />
          </Switch>
        </div>
      </Router>
    )
  }
};

const PrivateRoute = ({ component: Component, activeItem: activeitem, updateNav: updatenav, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      utils.isUserAuthenticated() ? (
        <div className='App'>
          <Navbar activeitem={activeitem} />
          <Component updatenav={updatenav} {...props} />
        </div>
      ) : (
        <Redirect
          to={{
            pathname: loginURL,
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      <div className='App'>
        <Navbar />
        <Component {...props} />
      </div>
    }
  />
);

const PublicNoNavRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      <Component {...props} />
    }
  />
);


// WEBPACK FOOTER //
// ./src/App.js